/* action type */
import type { Action } from '../../store/state/state-manager';

export const FINISH_ASSIGNMENT = 'FINISH_ASSIGNMENT';

/* action creator */
export const finishAssignmentAction = (actionPayload: Action['payload']) => {
  return {
    type: FINISH_ASSIGNMENT,
    payload: actionPayload
  };
};
